import { AlertCircle, Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";

export const RATE_OVERLAP_MSG = "These dates overlap an existing mileage-rate period. Please choose dates that do not overlap an existing mileage-rate period.";

export const overlappingRows = (rows) => {
  const bad = new Set();
  rows.forEach((a, i) => rows.forEach((b, j) => {
    if (i < j && a.start && a.end && b.start && b.end && a.start <= b.end && b.start <= a.end) bad.add(i).add(j);
  }));
  return bad;
};

export const RateTable = ({ rows, onChange }) => {
  const overlaps = overlappingRows(rows);
  const update = (i, k, v) => onChange(rows.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  const remove = (i) => onChange(rows.filter((_, j) => j !== i));
  const add = () => {
    const y = rows.length ? Number(rows[rows.length - 1].end.slice(0, 4)) + 1 : new Date().getFullYear();
    onChange([...rows, { start: `${y}-01-01`, end: `${y}-12-31`, rate: "" }]);
  };
  return (
    <div className="space-y-3" data-testid="rate-table">
      <div className="hidden sm:grid grid-cols-[1fr_1fr_140px_44px] gap-3 mt-overline">
        <span>From</span>
        <span>To</span>
        <span>$ per mile</span>
        <span />
      </div>
      {rows.map((r, i) => (
        <div key={i} className={`grid grid-cols-2 sm:grid-cols-[1fr_1fr_140px_44px] gap-3 items-center p-3 rounded-xl ${overlaps.has(i) ? "bg-red-50 ring-1 ring-red-300" : "sm:p-0 bg-slate-50 sm:bg-transparent"}`} data-testid={`rate-row-${i}`} data-overlap={overlaps.has(i) ? "true" : "false"}>
          <Input type="date" required value={r.start} onChange={(e) => update(i, "start", e.target.value)} className={`h-11 ${overlaps.has(i) ? "border-red-400" : ""}`} aria-label="From" aria-invalid={overlaps.has(i)} data-testid={`rate-start-${i}`} />
          <Input type="date" required value={r.end} onChange={(e) => update(i, "end", e.target.value)} className={`h-11 ${overlaps.has(i) ? "border-red-400" : ""}`} aria-label="To" aria-invalid={overlaps.has(i)} data-testid={`rate-end-${i}`} />
          <Input type="number" inputMode="decimal" step="0.001" min="0" max="5" required value={r.rate} onChange={(e) => update(i, "rate", e.target.value)} className="h-11 font-mono" aria-label="Rate per mile" data-testid={`rate-value-${i}`} />
          <button type="button" onClick={() => remove(i)} disabled={rows.length === 1} className="h-11 w-11 rounded-lg flex items-center justify-center text-red-600 hover:bg-red-50 disabled:opacity-30 justify-self-end" aria-label="Remove period" data-testid={`rate-remove-${i}`}>
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      ))}
      {overlaps.size > 0 && (
        <p role="alert" className="flex items-start gap-2 text-sm font-semibold text-red-700 bg-red-50 rounded-lg px-3 py-2" data-testid="rate-overlap-error">
          <AlertCircle className="w-4 h-4 mt-0.5 shrink-0" /> {RATE_OVERLAP_MSG}
        </p>
      )}
      <button type="button" onClick={add} className="mt-btn-outline" data-testid="rate-add-button">
        <Plus className="w-4 h-4" /> Add rate period
      </button>
    </div>
  );
};
